import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";

import ElementaryParts from './ElementaryParts';
import SingleDOF from './SingleDOF';
import FreeVibrations from "./FreeVibrations";
import ForcedVibrations from "./ForcedVibrations";
import SystemKinematics from "./SystemKinematics";
import Resonance from "./Resonance";
import MDOF from "./MDOF";
import Modal from "./Modal";
import Lagrangian from "./Lagrangian";
import Continuous from "./Continuous";
import Transfer from "./Transfer";
import StateSpace from "./StateSpace";
import Experiments from "./Experiments";
import VibrationControl from "./VibrationControl";
import TorsionalVibrations from "./TorsionalVibrations";
import NonlinearVibrations from "./NonlinearVibrations";
import RandomVibrations from "./RandomVibrations";
import NumericalMethods from "./NumericalMethods";

const ChangeComponents = {
    
    elementaryparts: ElementaryParts,
    singledof: SingleDOF,
    freevibrations: FreeVibrations,
    forcedvibrations: ForcedVibrations,
    systemkinematics: SystemKinematics,
    resonance: Resonance,
    mdof: MDOF,
    modal: Modal,
    lagrangian: Lagrangian,
    continuous: Continuous,
    transfer: Transfer,
    statespace: StateSpace,
    experiments: Experiments,
    vibrationcontrol: VibrationControl,
    torsionalvibrations: TorsionalVibrations,
    nonlinearvibrations: NonlinearVibrations,
    randomvibrations: RandomVibrations,
    numericalmethods: NumericalMethods,

  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }